import { buildVariantContext, getBrightnessFn } from './brightness-fns';
import { sampleDotStudioBrightness } from './dot-engine/density-field';
import { hashSeed } from './dot-engine/math';
import {
  type DensityFieldConfig,
  type GenerativeVariant,
  isDotStudioMode,
} from './dot-engine/types';

export function sampleGenerativeBrightness(
  u: number,
  v: number,
  variant: GenerativeVariant,
  seed: number | string,
  width: number,
  height: number,
  densityConfig?: DensityFieldConfig,
): number {
  if (isDotStudioMode(variant)) {
    return sampleDotStudioBrightness(variant, u, v, width, height, seed, densityConfig);
  }
  const ctx = buildVariantContext(typeof seed === 'number' ? seed : hashSeed(String(seed)));
  return getBrightnessFn(variant)(u, v, ctx);
}
